export const HOO_ACCOMODATION_STATE_KEY = 'HOO_ACCOMODATION_REDUCER';
// export const getTemplateById = (state: any, RequestId: string) =>
export const getOffices = (state: any) => state[HOO_ACCOMODATION_STATE_KEY].offices;
export const getEmployees = (state: any) => state[HOO_ACCOMODATION_STATE_KEY].employees;
export const getHooPatterns = (state: any) => state[HOO_ACCOMODATION_STATE_KEY].templatePatterns;
export const getRCDByLocationNumber = (state: any) => state[HOO_ACCOMODATION_STATE_KEY].rcd;
export const getCurrentHooPattern = (state: any) => state[HOO_ACCOMODATION_STATE_KEY].currentTemplatePattern;
export const getChangeResults = (state: any) => state[HOO_ACCOMODATION_STATE_KEY].changeResults;
export const getSuccessErrorReport = (state: any) => state[HOO_ACCOMODATION_STATE_KEY].successErrorReport;
export const getHooById = (state: any, exceptionId: string) =>
  state[HOO_ACCOMODATION_STATE_KEY].exception.contents.find((exception) => exception.exceptionId === exceptionId);

export const getHooAccomodations = (state) =>
  state[HOO_ACCOMODATION_STATE_KEY].requests.map(({ RequestId, ...rest }, idx) => ({
    key: `${RequestId}-${idx}`,
    RequestId,
    ...rest,
  }));

export const getLoading = (state) => state[HOO_ACCOMODATION_STATE_KEY].loading;
export const getCurrentPattern = (state: any) => state[HOO_ACCOMODATION_STATE_KEY].currentPattern;
export const getSaveLoading = (state: any) => state[HOO_ACCOMODATION_STATE_KEY].saveLoading;
export const getSaveAccommodationSuccess = (state: any) => state[HOO_ACCOMODATION_STATE_KEY].saveAccommodationSuccess;

export const getSaveAccommodationFailureMssg = (state: any) =>
  state[HOO_ACCOMODATION_STATE_KEY].saveAccommodationFailureMssg;

export const getRequestors = (state: any) => state[HOO_ACCOMODATION_STATE_KEY].requestors;
export const getLocations = (state: any) => state[HOO_ACCOMODATION_STATE_KEY].locations;
export const getUnplannedLocations = (state: any) => state[HOO_ACCOMODATION_STATE_KEY].unplannedLocations;
export const getReasons = (state: any) => state[HOO_ACCOMODATION_STATE_KEY].reasons;
export const getAllRequestorData = (state: any) => state[HOO_ACCOMODATION_STATE_KEY].allRequestorData;
export const getLoadingRequestors = (state: any) => state[HOO_ACCOMODATION_STATE_KEY].loadingRequestors;
export const getLoadingLocations = (state: any) => state[HOO_ACCOMODATION_STATE_KEY].loadingLocations;
export const getSearchHooRequests = (state: any) => state[HOO_ACCOMODATION_STATE_KEY].search;
export const getHoursOptions = (state: any) => state[HOO_ACCOMODATION_STATE_KEY].hoursOptions;
export const getRequestReasons = (state: any) => state[HOO_ACCOMODATION_STATE_KEY].requestReasons;
export const getRequestTypes = (state: any) => state[HOO_ACCOMODATION_STATE_KEY].requestTypes;
export const getExportLoading = (state: any) => state[HOO_ACCOMODATION_STATE_KEY].exportLoading;
